import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import actionFilter from "../../../store/advancedfilter/action";

class TeamTypes extends Component {
  onChange(item) {
    console.log('Rendering checkbox for:', item); // Debug log

    // Create a deep copy of the teamTypes array to avoid mutation
    const updatedTeamTypes = this.props.filterState.filterData.teamTypes.map(teamType => {
      if (teamType.id === item.id) {
        // Return a new object with toggled checked state
        return {
          ...teamType,
          checked: !teamType.checked
        };
      }
      return teamType;
    });

    // Update the filter data with the new array
    this.props.setFilterData({
      ...this.props.filterState.filterData,
      teamTypes: updatedTeamTypes
    });
  }
  chechboxes(item, index) {
    return (
      <li class="chechbox-list_item" key={"teamtypitem-" + index}>
        <span
          className="card-text custom-checkbox ml-4"
          key={"ttitem-" + index}
        >
          <input
            type="checkbox"
            htmlFor={"ttitem-" + index}
            value={item.id}
            checked={item.checked}
            className="custom-control-input"
            id={"ttitem-" + index}
            name={"ttitem-" + index}
            onChange={() => this.onChange(item)}
          />

          <label
            className="custom-control-label"
            htmlFor={"ttitem-" + index}
            style={{ color: this.props.isMobile ? "white" : null }}
          >
            {item.teamTypeName}
            <small className="totalCount">{`(${item.total})`}</small>
          </label>
        </span>
      </li>
    );
  }

  render() {
    return (
      <>
        {this.props.isMobile !== true ? (
          <>
            <h4>Team Types</h4>
            <hr />
          </>
        ) : (
          ""
        )}
        <div className="filter-fields-scroll">
          <ul className="chechbox-list">
            {this.props.filterState.filterData.teamTypes &&
              !_.isEmpty(this.props.filterState.filterData) &&
              this.props.filterState.filterData.teamTypes.map((item, index) =>
                this.chechboxes(item, index)
              )}
          </ul>
        </div>
        <div className="height-scroll"></div>
      </>
    );
  }
}

export default connect((state) => ({ filterState: state.advancedFilter }), {
  ...actionFilter,
})(TeamTypes);
